import { ThemeProvider, createTheme } from "@mui/material/styles";
import React, { createContext } from "react";
import PropTypes from "prop-types";

import CssBaseline from "@mui/material/CssBaseline";

export const DonationContext = createContext({
    appId: null,
});

const DonationProvider = ({
    children,
    appId,
    backgroundColor,
    primaryTextColor,
}) => {
    const theme = createTheme({
        palette: {
            background: {
                default: backgroundColor ?? "#ffffff",
            },
            text: {
                primary: primaryTextColor ?? "#000",
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <DonationContext.Provider value={{ appId }}>
                <CssBaseline />
                {children}
            </DonationContext.Provider>
        </ThemeProvider>
    );
};
DonationProvider.propTypes = {
    children: PropTypes.node.isRequired,
    appId: PropTypes.number,
    backgroundColor: PropTypes.string,
    primaryTextColor: PropTypes.string,
};

export default DonationProvider;
